import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { variantEndpoints } from '../../../../constants';
import { DeleteItemsInput } from '../../../../types';
import { PaginationRequest } from '../../../../types/pagination-request';
import { IVariant, StockVariants } from '../../entities/variant';
import { CreateVariantInput, UpdateVariantInput } from '../../schemas/variant.schema';

class VariantsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (variant: CreateVariantInput): Promise<IVariant> => {
    return this.#requestInstance.post(variantEndpoints.variant, variant);
  };

  deleteVariant = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(variantEndpoints.getVariantById(id));
  };

  deleteManyVariants = async (input: DeleteItemsInput): Promise<void> => {
    return this.#requestInstance.delete(variantEndpoints.variant, { data: input });
  };

  getVariantById = async (id: number): Promise<IVariant> => {
    return this.#requestInstance.get(variantEndpoints.getVariantById(id));
  };

  getVariants = async (data?: PaginationRequest): Promise<StockVariants> => {
    return this.#requestInstance.get(variantEndpoints.variant, { params: data });
  };

  updateVariant = async (input: UpdateVariantInput): Promise<IVariant> => {
    return this.#requestInstance.patch(variantEndpoints.getVariantById(input.id), input.variant);
  };
}

export const variantsApi = new VariantsApi(axios);
